/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "business": {
            "nested": {
              "subcategories": {
                "nested": {
                  "BusinessSubcategory": {
                    "values": {
                      "BUSINESS_SUBCATEGORY_UNKNOWN": 0,
                      "BUSINESS_SUBCATEGORY_ACCOUNTING": 1,
                      "BUSINESS_SUBCATEGORY_ACUPUNCTURE": 2,
                      "BUSINESS_SUBCATEGORY_ALTERNATIVE_MEDICINE": 3,
                      "BUSINESS_SUBCATEGORY_ANTIQUE": 4,
                      "BUSINESS_SUBCATEGORY_ART_PHOTO_AND_FILM": 5,
                      "BUSINESS_SUBCATEGORY_AUTOMOTIVE_SERVICES": 6,
                      "BUSINESS_SUBCATEGORY_BAKERY": 7,
                      "BUSINESS_SUBCATEGORY_BAR_CLUB_LOUNGE": 8,
                      "BUSINESS_SUBCATEGORY_BEAUTY_CHIROPRACTOR": 9,
                      "BUSINESS_SUBCATEGORY_BEAUTY_SALON": 10,
                      "BUSINESS_SUBCATEGORY_BOOKS_MAGS_MUSIC_AND_VIDEO": 11,
                      "BUSINESS_SUBCATEGORY_BOOKS_MUSIC_AND_VIDEO": 12,
                      "BUSINESS_SUBCATEGORY_BRICKLAYING": 13,
                      "BUSINESS_SUBCATEGORY_BUILDING": 14,
                      "BUSINESS_SUBCATEGORY_BUS": 15,
                      "BUSINESS_SUBCATEGORY_BUS_COACH_SERVICES": 16,
                      "BUSINESS_SUBCATEGORY_CAPITAL": 17,
                      "BUSINESS_SUBCATEGORY_CAR_BIKE_BICYCLE_SHOP": 18,
                      "BUSINESS_SUBCATEGORY_CARE_GIVER": 19,
                      "BUSINESS_SUBCATEGORY_CARER": 20,
                      "BUSINESS_SUBCATEGORY_CARPENTRY": 21,
                      "BUSINESS_SUBCATEGORY_CARPET_CLEANING": 22,
                      "BUSINESS_SUBCATEGORY_CATERER": 23,
                      "BUSINESS_SUBCATEGORY_CATERING": 24,
                      "BUSINESS_SUBCATEGORY_CHARITABLE_ORGANIZATION": 25,
                      "BUSINESS_SUBCATEGORY_CHILD_CARE": 26,
                      "BUSINESS_SUBCATEGORY_CHILDCARE": 27,
                      "BUSINESS_SUBCATEGORY_CHIROPRACTOR": 28,
                      "BUSINESS_SUBCATEGORY_CHIROPRACTOR_ACUPUNCTURE": 29,
                      "BUSINESS_SUBCATEGORY_CHIROPRACTOR_OSTEOPATH": 30,
                      "BUSINESS_SUBCATEGORY_CLEANING": 31,
                      "BUSINESS_SUBCATEGORY_CLOTHING_AND_ACCESSORIES": 32,
                      "BUSINESS_SUBCATEGORY_CLOTHING_AND_SHOE_REPAIR_ALTERATIONS": 33,
                      "BUSINESS_SUBCATEGORY_CLOTHING_SHOE_REPAIR_ALTERATIONS": 34,
                      "BUSINESS_SUBCATEGORY_COFFEE_SHOP_CAFE": 35,
                      "BUSINESS_SUBCATEGORY_COFFEE_TEA_SHOP": 36,
                      "BUSINESS_SUBCATEGORY_COMPUTER_ELECTRONICS_AND_APPLIANCE_REPAIR": 37,
                      "BUSINESS_SUBCATEGORY_COMPUTER_EQUIPMENT_MAINTENANCE": 38,
                      "BUSINESS_SUBCATEGORY_CONCRETING": 39,
                      "BUSINESS_SUBCATEGORY_CONSULTING": 40,
                      "BUSINESS_SUBCATEGORY_CONVENIENCE_STORE": 41,
                      "BUSINESS_SUBCATEGORY_COSMETIC_SURGERY": 42,
                      "BUSINESS_SUBCATEGORY_COUNSELLOR": 43,
                      "BUSINESS_SUBCATEGORY_COUNTER_SERVICE_RESTAURANT": 44,
                      "BUSINESS_SUBCATEGORY_CULTURE_SCHOOL": 45,
                      "BUSINESS_SUBCATEGORY_DELIVERY": 46,
                      "BUSINESS_SUBCATEGORY_DENTIST": 47,
                      "BUSINESS_SUBCATEGORY_DENTIST_ORTHODONTIST": 48,
                      "BUSINESS_SUBCATEGORY_DESIGN": 49,
                      "BUSINESS_SUBCATEGORY_DIETITIAN": 50,
                      "BUSINESS_SUBCATEGORY_DIY_SHOP": 51,
                      "BUSINESS_SUBCATEGORY_DRY_CLEANING_AND_LAUNDRY": 52,
                      "BUSINESS_SUBCATEGORY_ELECTRICAL_SERVICES": 53,
                      "BUSINESS_SUBCATEGORY_ELECTRONICS": 54,
                      "BUSINESS_SUBCATEGORY_EMPLOYEE_COUNT": 55,
                      "BUSINESS_SUBCATEGORY_ESTATE_AGENCY": 56,
                      "BUSINESS_SUBCATEGORY_ESTHETIC_SALON": 57,
                      "BUSINESS_SUBCATEGORY_EVENTS_FESTIVALS": 58,
                      "BUSINESS_SUBCATEGORY_EYEWEAR": 59,
                      "BUSINESS_SUBCATEGORY_EYEWEAR_ACOUSTIC_AID": 60,
                      "BUSINESS_SUBCATEGORY_FLOORING": 61,
                      "BUSINESS_SUBCATEGORY_FLOWERS_AND_GIFTS": 62,
                      "BUSINESS_SUBCATEGORY_FOOD_SUPPLIER": 63,
                      "BUSINESS_SUBCATEGORY_FOOD_TRUCK_CART": 64,
                      "BUSINESS_SUBCATEGORY_FURNITURE_HOME_GOODS": 65,
                      "BUSINESS_SUBCATEGORY_FURNITURE_HOMEWARE": 66,
                      "BUSINESS_SUBCATEGORY_FURNITURE_OFFICE_SUPPLY": 67,
                      "BUSINESS_SUBCATEGORY_GALLERY_ART_PAINTING": 68,
                      "BUSINESS_SUBCATEGORY_GENERAL_CONTRACTING": 69,
                      "BUSINESS_SUBCATEGORY_GLAZING": 70,
                      "BUSINESS_SUBCATEGORY_GROCERS": 71,
                      "BUSINESS_SUBCATEGORY_GROCERY_MARKET": 72,
                      "BUSINESS_SUBCATEGORY_GYM_HEALTH_CLUB": 73,
                      "BUSINESS_SUBCATEGORY_HAIR_GROW": 74,
                      "BUSINESS_SUBCATEGORY_HAIR_REMOVAL": 75,
                      "BUSINESS_SUBCATEGORY_HAIR_SALON_BARBERSHOP": 76,
                      "BUSINESS_SUBCATEGORY_HARDWARE_STORE": 77,
                      "BUSINESS_SUBCATEGORY_HEATING_AND_AIR_CONDITIONING": 78,
                      "BUSINESS_SUBCATEGORY_HOBBY_SHOP": 79,
                      "BUSINESS_SUBCATEGORY_HOME_IMPROVEMENT_AND_BUILDING_SUPPLIES": 80,
                      "BUSINESS_SUBCATEGORY_HOTEL": 81,
                      "BUSINESS_SUBCATEGORY_HOUSE_CLEANING": 82,
                      "BUSINESS_SUBCATEGORY_INDEPENDENT_STYLIST_BARBER": 83,
                      "BUSINESS_SUBCATEGORY_INDEPENDENT_STYLIST_BEAUTY_CONSULTING": 84,
                      "BUSINESS_SUBCATEGORY_INSTALLATION_SERVICES": 85,
                      "BUSINESS_SUBCATEGORY_INSTRUCTOR_TEACHER": 86,
                      "BUSINESS_SUBCATEGORY_INTERIOR_DESIGN": 87,
                      "BUSINESS_SUBCATEGORY_JEWELLERY_WATCH_REPAIR": 88,
                      "BUSINESS_SUBCATEGORY_JEWELRY_AND_WATCHES": 89,
                      "BUSINESS_SUBCATEGORY_JUNK_REMOVAL": 90,
                      "BUSINESS_SUBCATEGORY_KIMONO": 91,
                      "BUSINESS_SUBCATEGORY_LANDSCAPING": 92,
                      "BUSINESS_SUBCATEGORY_LANGUAGE_SCHOOLS": 93,
                      "BUSINESS_SUBCATEGORY_LEASURE_CENTRE": 94,
                      "BUSINESS_SUBCATEGORY_LEGAL_SERVICES": 95,
                      "BUSINESS_SUBCATEGORY_LIMOUSINE": 96,
                      "BUSINESS_SUBCATEGORY_LIQUOR_SHOP": 97,
                      "BUSINESS_SUBCATEGORY_LOCKSMITH_SERVICES": 98,
                      "BUSINESS_SUBCATEGORY_MARKET": 99,
                      "BUSINESS_SUBCATEGORY_MARKETING_ADVERTISING": 100,
                      "BUSINESS_SUBCATEGORY_MARKETING_ADVERTISING_PRINTING": 101,
                      "BUSINESS_SUBCATEGORY_MARRIAGE_CONSULTANCY": 102,
                      "BUSINESS_SUBCATEGORY_MASSAGE": 103,
                      "BUSINESS_SUBCATEGORY_MASSAGE_THERAPIST": 104,
                      "BUSINESS_SUBCATEGORY_MEDICAL_PRACTITIONER": 105,
                      "BUSINESS_SUBCATEGORY_MEDICINE_DRUG_STORE": 106,
                      "BUSINESS_SUBCATEGORY_MEMBERSHIP_ORGANIZATION": 107,
                      "BUSINESS_SUBCATEGORY_MISCELLANEOUS_GOODS": 108,
                      "BUSINESS_SUBCATEGORY_MISCELLANEOUS_SERVICES": 109,
                      "BUSINESS_SUBCATEGORY_MOVIES_FILM": 110,
                      "BUSINESS_SUBCATEGORY_MOVIES_PERFORMING_ARTS": 111,
                      "BUSINESS_SUBCATEGORY_MOVING": 112,
                      "BUSINESS_SUBCATEGORY_MUSEUM_CULTURAL": 113,
                      "BUSINESS_SUBCATEGORY_MUSIC": 114,
                      "BUSINESS_SUBCATEGORY_MUSIC_STUDIO": 115,
                      "BUSINESS_SUBCATEGORY_MUSICAL_INSTRUMENT": 116,
                      "BUSINESS_SUBCATEGORY_NAIL_SALON": 117,
                      "BUSINESS_SUBCATEGORY_NANNY_SERVICES": 118,
                      "BUSINESS_SUBCATEGORY_NEWSAGENT": 119,
                      "BUSINESS_SUBCATEGORY_NOTARY_SERVICES": 120,
                      "BUSINESS_SUBCATEGORY_OCCUPATIONAL_THERAPIST": 121,
                      "BUSINESS_SUBCATEGORY_OFFICE_SUPPLIES": 122,
                      "BUSINESS_SUBCATEGORY_OFFICE_SUPPLY": 123,
                      "BUSINESS_SUBCATEGORY_OPTICIAN": 124,
                      "BUSINESS_SUBCATEGORY_OPTOMETRIST_EYE_CARE": 125,
                      "BUSINESS_SUBCATEGORY_OPTOMETRIST_LASER_EYE_SURGERY": 126,
                      "BUSINESS_SUBCATEGORY_ORDER_MADE_APPAREL": 127,
                      "BUSINESS_SUBCATEGORY_ORDER_MADE_FURNITURE": 128,
                      "BUSINESS_SUBCATEGORY_OTHER": 129,
                      "BUSINESS_SUBCATEGORY_OTHER_REPAIR": 130,
                      "BUSINESS_SUBCATEGORY_OUTDOOR_MARKETS": 131,
                      "BUSINESS_SUBCATEGORY_PAINTING": 132,
                      "BUSINESS_SUBCATEGORY_PAINTING_AND_DECORATING": 133,
                      "BUSINESS_SUBCATEGORY_PERFORMING_ARTS": 134,
                      "BUSINESS_SUBCATEGORY_PERSONAL_COMPUTER_SCHOOL": 135,
                      "BUSINESS_SUBCATEGORY_PERSONAL_TRAINER": 136,
                      "BUSINESS_SUBCATEGORY_PEST_CONTROL": 137,
                      "BUSINESS_SUBCATEGORY_PET_SALON_TRIMMER": 138,
                      "BUSINESS_SUBCATEGORY_PET_STORE": 139,
                      "BUSINESS_SUBCATEGORY_PHOTOGRAPHY": 140,
                      "BUSINESS_SUBCATEGORY_PHYSIOTHERAPIST": 141,
                      "BUSINESS_SUBCATEGORY_PLASTERING_AND_CEILING_SERVICES": 142,
                      "BUSINESS_SUBCATEGORY_PLUMBING": 143,
                      "BUSINESS_SUBCATEGORY_PODIATRIST": 144,
                      "BUSINESS_SUBCATEGORY_POLITICAL_ORGANIZATION": 145,
                      "BUSINESS_SUBCATEGORY_POTTERY_CRAFT": 146,
                      "BUSINESS_SUBCATEGORY_PREP_CRAM_SCHOOLS": 147,
                      "BUSINESS_SUBCATEGORY_PRINTING_SERVICES": 148,
                      "BUSINESS_SUBCATEGORY_PRIVATE_CHEF": 149,
                      "BUSINESS_SUBCATEGORY_PRIVATE_SHUTTLE": 150,
                      "BUSINESS_SUBCATEGORY_PRIVATE_SHUTTLE_BUS": 151,
                      "BUSINESS_SUBCATEGORY_PSYCHIATRIST": 152,
                      "BUSINESS_SUBCATEGORY_PUB_BAR_CLUB": 153,
                      "BUSINESS_SUBCATEGORY_QUICK_SERVICE_RESTAURANT": 154,
                      "BUSINESS_SUBCATEGORY_REAL_ESTATE": 155,
                      "BUSINESS_SUBCATEGORY_REAL_ESTATE_RENTAL_SHARE_ACCOMMODATION": 156,
                      "BUSINESS_SUBCATEGORY_RECYCLE_SHOP": 157,
                      "BUSINESS_SUBCATEGORY_RELIGIOUS_ORGANIZATION": 158,
                      "BUSINESS_SUBCATEGORY_RENTAL_CAR": 159,
                      "BUSINESS_SUBCATEGORY_RENTAL_OFFICE_COWORKING_SPACE": 160,
                      "BUSINESS_SUBCATEGORY_ROOFING": 161,
                      "BUSINESS_SUBCATEGORY_RUBBISH_REMOVAL": 162,
                      "BUSINESS_SUBCATEGORY_SCHOOL": 163,
                      "BUSINESS_SUBCATEGORY_SIT_DOWN_RESTAURANT": 164,
                      "BUSINESS_SUBCATEGORY_SOFTWARE_DEVELOPMENT": 165,
                      "BUSINESS_SUBCATEGORY_SPA": 166,
                      "BUSINESS_SUBCATEGORY_SPECIALTY_SHOP": 167,
                      "BUSINESS_SUBCATEGORY_SPORTING_EVENTS": 168,
                      "BUSINESS_SUBCATEGORY_SPORTING_GOODS": 169,
                      "BUSINESS_SUBCATEGORY_SPORTS_RECREATION": 170,
                      "BUSINESS_SUBCATEGORY_TABLE_SERVICE_RESTAURANT": 171,
                      "BUSINESS_SUBCATEGORY_TAKEAWAY_FOOD_SHOP": 172,
                      "BUSINESS_SUBCATEGORY_TANNING_SALON": 173,
                      "BUSINESS_SUBCATEGORY_TATTOO_PIERCING": 174,
                      "BUSINESS_SUBCATEGORY_TAXI": 175,
                      "BUSINESS_SUBCATEGORY_THERAPIST": 176,
                      "BUSINESS_SUBCATEGORY_TICKET_SALES": 177,
                      "BUSINESS_SUBCATEGORY_TILING_AND_CARPETING": 178,
                      "BUSINESS_SUBCATEGORY_TOURISM": 179,
                      "BUSINESS_SUBCATEGORY_TOWN_CAR": 180,
                      "BUSINESS_SUBCATEGORY_TRAVEL_AGENCY": 181,
                      "BUSINESS_SUBCATEGORY_TUTOR": 182,
                      "BUSINESS_SUBCATEGORY_VETERINARY_SERVICES": 183,
                      "BUSINESS_SUBCATEGORY_WATCH_JEWELRY_REPAIR": 184,
                      "BUSINESS_SUBCATEGORY_WEB_DESIGN": 185,
                      "BUSINESS_SUBCATEGORY_YOGA_PILATES": 186,
                      "BUSINESS_SUBCATEGORY_GHOST_KITCHEN": 187,
                      "BUSINESS_SUBCATEGORY_BARS_AND_BRASSERIES": 188,
                      "BUSINESS_SUBCATEGORY_TOBACCO_ECIGS_VAPE": 189,
                      "BUSINESS_SUBCATEGORY_HOME_HEALTH_CARE_SERVICE": 190,
                      "BUSINESS_SUBCATEGORY_ANESTHESIOLOGY": 191,
                      "BUSINESS_SUBCATEGORY_AUDIOLOGY": 192,
                      "BUSINESS_SUBCATEGORY_BARBER_SHOP": 193,
                      "BUSINESS_SUBCATEGORY_BARRE": 194,
                      "BUSINESS_SUBCATEGORY_BLOW_DRY_BAR": 195,
                      "BUSINESS_SUBCATEGORY_BODY_GROOMING": 196,
                      "BUSINESS_SUBCATEGORY_BOXING_GYM": 197,
                      "BUSINESS_SUBCATEGORY_BROWS_LASHES": 198,
                      "BUSINESS_SUBCATEGORY_CARDIOLOGY": 199,
                      "BUSINESS_SUBCATEGORY_CROSS_TRAINING_BOOTCAMP": 200,
                      "BUSINESS_SUBCATEGORY_CROSSFIT_GYM": 201,
                      "BUSINESS_SUBCATEGORY_DANCE_STUDIO": 202,
                      "BUSINESS_SUBCATEGORY_DAY_SPA": 203,
                      "BUSINESS_SUBCATEGORY_DENTISTRY": 204,
                      "BUSINESS_SUBCATEGORY_DERMATOLOGY": 205,
                      "BUSINESS_SUBCATEGORY_EAR_BODY_PIERCING": 206,
                      "BUSINESS_SUBCATEGORY_EMERGENCY_MEDICINE": 207,
                      "BUSINESS_SUBCATEGORY_FAMILY_MEDICINE": 208,
                      "BUSINESS_SUBCATEGORY_FITNESS_STUDIO": 209,
                      "BUSINESS_SUBCATEGORY_FULL_SERVICE_SALON": 210,
                      "BUSINESS_SUBCATEGORY_GENERAL_SURGERY": 211,
                      "BUSINESS_SUBCATEGORY_GERIATRICS": 212,
                      "BUSINESS_SUBCATEGORY_HAIR_REMOVAL_WAXING": 213,
                      "BUSINESS_SUBCATEGORY_HAIR_SALON": 214,
                      "BUSINESS_SUBCATEGORY_INDOOR_CYCLING_STUDIO": 215,
                      "BUSINESS_SUBCATEGORY_INTERNAL_MEDICINE": 216,
                      "BUSINESS_SUBCATEGORY_MAKEUP_ARTISTRY": 217,
                      "BUSINESS_SUBCATEGORY_MARTIAL_ARTS": 218,
                      "BUSINESS_SUBCATEGORY_MASSAGE_THERAPY": 219,
                      "BUSINESS_SUBCATEGORY_MASSAGE_PHYSIOTHERAPY": 220,
                      "BUSINESS_SUBCATEGORY_MED_SPA": 221,
                      "BUSINESS_SUBCATEGORY_MEDICAL_GENETICS": 222,
                      "BUSINESS_SUBCATEGORY_MEDITATION": 223,
                      "BUSINESS_SUBCATEGORY_NEPHROLOGY": 224,
                      "BUSINESS_SUBCATEGORY_NEUROLOGY": 225,
                      "BUSINESS_SUBCATEGORY_NUTRITION": 226,
                      "BUSINESS_SUBCATEGORY_NUTRITION_DIETETICS": 227,
                      "BUSINESS_SUBCATEGORY_OBSTETRICS_GYNECOLOGY": 228,
                      "BUSINESS_SUBCATEGORY_ONCOLOGY": 229,
                      "BUSINESS_SUBCATEGORY_OPHTHALMOLOGY": 230,
                      "BUSINESS_SUBCATEGORY_OPTOMETRY_EYEWEAR": 231,
                      "BUSINESS_SUBCATEGORY_ORTHODONTICS": 232,
                      "BUSINESS_SUBCATEGORY_PATHOLOGY": 233,
                      "BUSINESS_SUBCATEGORY_PEDIATRICS": 234,
                      "BUSINESS_SUBCATEGORY_PERSONAL_TRAINING": 235,
                      "BUSINESS_SUBCATEGORY_PET_BOARDING_DAYCARE": 236,
                      "BUSINESS_SUBCATEGORY_PET_GROOMING": 237,
                      "BUSINESS_SUBCATEGORY_PET_SITTING": 238,
                      "BUSINESS_SUBCATEGORY_PET_TRAINING": 239,
                      "BUSINESS_SUBCATEGORY_PET_WALKING": 240,
                      "BUSINESS_SUBCATEGORY_PILATES_STUDIO": 241,
                      "BUSINESS_SUBCATEGORY_PODIATRY": 242,
                      "BUSINESS_SUBCATEGORY_PSYCHIATRY": 243,
                      "BUSINESS_SUBCATEGORY_PSYCHOTHERAPY": 244,
                      "BUSINESS_SUBCATEGORY_RADIOLOGY": 245,
                      "BUSINESS_SUBCATEGORY_ROCK_CLIMBING": 246,
                      "BUSINESS_SUBCATEGORY_ROWING": 247,
                      "BUSINESS_SUBCATEGORY_SKIN_CARE_ESTHETICS": 248,
                      "BUSINESS_SUBCATEGORY_SPEECH_THERAPY": 249,
                      "BUSINESS_SUBCATEGORY_STRETCHING": 250,
                      "BUSINESS_SUBCATEGORY_SWIMMING_WATER_AEROBICS": 251,
                      "BUSINESS_SUBCATEGORY_TATTOO": 252,
                      "BUSINESS_SUBCATEGORY_UROLOGY": 253,
                      "BUSINESS_SUBCATEGORY_YOGA_STUDIO": 254,
                      "BUSINESS_SUBCATEGORY_ANTIQUE_SHOP": 255,
                      "BUSINESS_SUBCATEGORY_ARCHITECT": 256,
                      "BUSINESS_SUBCATEGORY_ART_AND_DESIGN": 257,
                      "BUSINESS_SUBCATEGORY_ART_PHOTO_AND_FILM_SHOP": 258,
                      "BUSINESS_SUBCATEGORY_BABY_CHILDRENS_GOODS": 259,
                      "BUSINESS_SUBCATEGORY_BAKERY_PASTRY_SHOP": 260,
                      "BUSINESS_SUBCATEGORY_BAR": 261,
                      "BUSINESS_SUBCATEGORY_BEAUTY_SUPPLIES": 262,
                      "BUSINESS_SUBCATEGORY_BEER_WINE_BOTTLE_SHOPS": 263,
                      "BUSINESS_SUBCATEGORY_BREWERY": 264,
                      "BUSINESS_SUBCATEGORY_BUSINESS_SERVICES": 265,
                      "BUSINESS_SUBCATEGORY_CANNABIS_SHOP": 266,
                      "BUSINESS_SUBCATEGORY_CAR_WASHES": 267,
                      "BUSINESS_SUBCATEGORY_CASUAL_DINING": 268,
                      "BUSINESS_SUBCATEGORY_CHEESE_SPECIALTY_FOOD_SHOPS": 269,
                      "BUSINESS_SUBCATEGORY_CLUB_LOUNGE": 270,
                      "BUSINESS_SUBCATEGORY_COFFEE_TEA_CAFE": 271,
                      "BUSINESS_SUBCATEGORY_CONSIGNMENT_THRIFT_RETAILER": 272,
                      "BUSINESS_SUBCATEGORY_COUNTER_SERVICE_RESTAURANT_OTHER": 273,
                      "BUSINESS_SUBCATEGORY_CUSTOM_FURNITURE": 274,
                      "BUSINESS_SUBCATEGORY_CUSTOM_JEWELRY": 275,
                      "BUSINESS_SUBCATEGORY_DESIGN_OTHER": 276,
                      "BUSINESS_SUBCATEGORY_DRUG_STORE_PHARMACY": 277,
                      "BUSINESS_SUBCATEGORY_FAST_CASUAL_RESTAURANT": 278,
                      "BUSINESS_SUBCATEGORY_FAST_FOOD_RESTAURANT": 279,
                      "BUSINESS_SUBCATEGORY_FINE_DINING": 280,
                      "BUSINESS_SUBCATEGORY_FOOD_HALL": 281,
                      "BUSINESS_SUBCATEGORY_FUNERAL_SERVICE_AND_CREMATORIES": 282,
                      "BUSINESS_SUBCATEGORY_GHOST_VIRTUAL_KITCHEN": 283,
                      "BUSINESS_SUBCATEGORY_GRAPHIC_DESIGN": 284,
                      "BUSINESS_SUBCATEGORY_HOBBY_TOY_GAME_SHOP": 285,
                      "BUSINESS_SUBCATEGORY_HOTEL_RESORT_RESTAURANTS": 286,
                      "BUSINESS_SUBCATEGORY_ICE_CREAM_SHOP": 287,
                      "BUSINESS_SUBCATEGORY_MEDICAL_AND_DENTAL_LABS": 288,
                      "BUSINESS_SUBCATEGORY_MOTOR_VEHICLES_AND_AUTOMOTIVE_PARTS": 289,
                      "BUSINESS_SUBCATEGORY_MOVING_AND_STORAGE": 290,
                      "BUSINESS_SUBCATEGORY_OTHER_MEDICAL_SERVICES": 291,
                      "BUSINESS_SUBCATEGORY_PIZZERIA": 292,
                      "BUSINESS_SUBCATEGORY_PLANTS_GARDEN_NURSERIES": 293,
                      "BUSINESS_SUBCATEGORY_POPUP_RESTAURANT": 294,
                      "BUSINESS_SUBCATEGORY_SPECIALTY_DRINK": 295,
                      "BUSINESS_SUBCATEGORY_TABLE_SERVICE_RESTAURANT_OTHER": 296,
                      "BUSINESS_SUBCATEGORY_TOWING_SERVICES": 297,
                      "BUSINESS_SUBCATEGORY_POP_UP_RESTAURANT": 298,
                      "BUSINESS_SUBCATEGORY_DATING_AND_ESCORT_SERVICES": 299,
                      "BUSINESS_SUBCATEGORY_FAST_CASUAL_FAST_FOOD_RESTAURANT": 300,
                      "BUSINESS_SUBCATEGORY_COFFEE_TEA_SPECIALTY_DRINK": 301,
                      "BUSINESS_SUBCATEGORY_CONCESSION_CART": 302,
                      "BUSINESS_SUBCATEGORY_FOOD_TRUCK": 303,
                      "BUSINESS_SUBCATEGORY_FOOD_AND_DRINK_OTHER": 304,
                      "BUSINESS_SUBCATEGORY_MARINE_SERVICES": 305,
                      "BUSINESS_SUBCATEGORY_POOL_AND_SPA": 306,
                      "BUSINESS_SUBCATEGORY_APPLIANCE_COMPUTER_ELECTRONICS_SERVICES": 307,
                      "BUSINESS_SUBCATEGORY_LOCKSMITH": 308,
                      "BUSINESS_SUBCATEGORY_CAR_WASHES_DETAILING": 309,
                      "BUSINESS_SUBCATEGORY_REMODELING": 310,
                      "BUSINESS_SUBCATEGORY_HANDYMAN": 311,
                      "BUSINESS_SUBCATEGORY_HEATING_VENTILATION_AND_AIR_CONDITIONING": 312,
                      "BUSINESS_SUBCATEGORY_ROOFING_AND_SIDING": 313,
                      "BUSINESS_SUBCATEGORY_HOME_AND_REPAIR_OTHER": 314,
                      "BUSINESS_SUBCATEGORY_PET_SERVICES": 315,
                      "BUSINESS_SUBCATEGORY_PROFESSIONAL_SERVICES_OTHER": 316,
                      "BUSINESS_SUBCATEGORY_BOOKS_MUSIC": 317,
                      "BUSINESS_SUBCATEGORY_CHILDRENS_CLOTHING_AND_GOODS": 318,
                      "BUSINESS_SUBCATEGORY_ART_AND_PRINT_STORE": 319,
                      "BUSINESS_SUBCATEGORY_FLOWER_SHOP": 320,
                      "BUSINESS_SUBCATEGORY_GIFT_SHOP": 321,
                      "BUSINESS_SUBCATEGORY_GARDEN_NURSERIES": 322,
                      "BUSINESS_SUBCATEGORY_HOME_GOODS_FURNISHINGS": 323,
                      "BUSINESS_SUBCATEGORY_DRUGSTORE_PHARMACY": 324,
                      "BUSINESS_SUBCATEGORY_TOBACCO_VAPE": 325,
                      "BUSINESS_SUBCATEGORY_RETAIL_OTHER": 326,
                      "BUSINESS_SUBCATEGORY_THRIFT_STORE": 327,
                      "BUSINESS_SUBCATEGORY_CONSIGNMENT_SHOP": 328,
                      "BUSINESS_SUBCATEGORY_AUTO_SUPPLIES": 329,
                      "BUSINESS_SUBCATEGORY_FIREWORKS_SHOP": 330,
                      "BUSINESS_SUBCATEGORY_SPECIALTY_FOOD_SHOPS": 331,
                      "BUSINESS_SUBCATEGORY_SALON": 332,
                      "BUSINESS_SUBCATEGORY_BEAUTY_OTHER": 333,
                      "BUSINESS_SUBCATEGORY_FITNESS_OTHER": 334,
                      "BUSINESS_SUBCATEGORY_SPORTS_INSTRUCTION_CLUBS": 335,
                      "BUSINESS_SUBCATEGORY_SPA_MASSAGE_THERAPY": 336,
                      "BUSINESS_SUBCATEGORY_IV_THERAPY": 337,
                      "BUSINESS_SUBCATEGORY_WELLNESS_OTHER": 338,
                      "BUSINESS_SUBCATEGORY_HEALTH_CARE_OTHER": 339,
                      "BUSINESS_SUBCATEGORY_DENTISTRY_ORTHODONTICS": 340,
                      "BUSINESS_SUBCATEGORY_PHYSICAL_THERAPY": 341,
                      "BUSINESS_SUBCATEGORY_PSYCHOTHERAPY_COUNSELING": 342,
                      "BUSINESS_SUBCATEGORY_LEISURE_AND_ENTERTAINMENT_OTHER": 343,
                      "BUSINESS_SUBCATEGORY_PRIVATE_SHUTTLE_CAR": 344,
                      "BUSINESS_SUBCATEGORY_TRANSPORTATION_OTHER": 345,
                      "BUSINESS_SUBCATEGORY_TEACHING_SERVICES": 346,
                      "BUSINESS_SUBCATEGORY_CHARITIES_EDUCATION_AND_MEMBERSHIP_OTHER": 347,
                      "BUSINESS_SUBCATEGORY_AUTOMOBILE_ASSOCIATIONS": 348
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.business?.nested?.subcategories?.nested?.BusinessSubcategory) {
  $root.addJSON(jsonData);
}

/**
 * This is the canonical list of business subcategories a merchant can select.
 * Each sub-category is associated with a squareup.onboard.business.categories.BusinessCategory.
 * The mapping between a category and subcategory is defined by configs in the onboard service:
 * https://git.sqcorp.co/projects/SQ/repos/onboard/browse/config/business_categories
 *
 * SOURCE BusinessSubcategory @ squareup/onboard/business/subcategories.proto at 8:1
 */
export const BusinessSubcategory = $root.lookupEnum('squareup.onboard.business.subcategories.BusinessSubcategory').values;